import { render, staticRenderFns } from "./Lesson1.vue?vue&type=template&id=478d8d4a&"
import script from "./Lesson1.vue?vue&type=script&lang=js&"
export * from "./Lesson1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../aristotle-website/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports